
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/spacing.st.css.js";
import "../Foundation/stylable/border.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "./LayoutBlocks/Header/Header.st.css.js";
import "./LayoutBlocks/Content/Content.st.css.js";
import "./LayoutBlocks/Footer/Footer.st.css.js";
import "./LayoutBlocks/Footnote/Footnote.st.css.js";
import "./LayoutBlocks/Illustration/Illustration.st.css.js";
import "../CloseButton/CloseButton.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_2_BaseModalLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_2_BaseModalLayout__root","controlButtons":"wds_1_220_2_BaseModalLayout__controlButtons","helpButton":"wds_1_220_2_BaseModalLayout__helpButton","closeButton":"wds_1_220_2_BaseModalLayout__closeButton","helpIcon":"wds_1_220_2_BaseModalLayout__helpIcon","header":"wds_1_220_2_BaseModalLayout__header","content":"wds_1_220_2_BaseModalLayout__content","footer":"wds_1_220_2_BaseModalLayout__footer","footnote":"wds_1_220_2_BaseModalLayout__footnote","illustration":"wds_1_220_2_BaseModalLayout__illustration"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"helpIconSize":"24px"}; 
export var vars = {"wds-space-50":"--wds-space-50","wds-color-fill-surface-modal":"--wds-color-fill-surface-modal","wds-border-radius-surface-modal":"--wds-border-radius-surface-modal","wds-shadow-surface-modal":"--wds-shadow-surface-modal","wds-custom-modal-header-padding-vertical":"--wds-custom-modal-header-padding-vertical","wds-custom-modal-header-padding-right":"--wds-custom-modal-header-padding-right"}; 




